export default __webpack_public_path__ + "static/media/UN_Goal_9.45725b4d.png";